import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Alert, AlertColor, AlertTitle, Box, Slide, useTheme } from '@mui/material';
import { useAlert } from '../../hooks/useAlert';
import { ITheme } from '../theme';
import { boxStyles, useStyles } from './alertPopup.styles';

export const AlertPopup = (): JSX.Element => {
  const { text, type } = useAlert();
  const theme: ITheme | undefined = useTheme();
  const classes = useStyles({ theme });
  const statusCode = Number(text.slice(text.length - 3, text.length));

  const errorMessage: Record<number, string> = {
    409: 'USER ALREADY EXISTS',
    400: text,
    401: 'UNAUTHORIZED',
    701: 'YOU HAVE SUCCESSFULLY UNBLOCKED A VOLUNTEER',
    702: 'YOU HAVE SUCCESSFULLY BLOCKED A VOLUNTEER',
    777: 'YOU HAVE SUCCESSFULLY EDITING REQUIRED QUALIFICATIONS',
    888: 'YOU HAVE SUCCESSFULLY CANCELED OPPORTUNITY',
    999: 'YOU HAVE SUCCESSFULLY CREATED REQUIRED QUALIFICATIONS',
  };

  if (text && type && true) {
    return (
      <div className={classes.alert}>
        <Slide direction="left" in={true} mountOnEnter unmountOnExit>
          <Alert
            icon={
              <Box sx={boxStyles}>
                {
                  statusCode > 700
                    ? <CheckCircleIcon />
                    : <WarningAmberRoundedIcon />
                }
              </Box>
            }
            severity={(type as AlertColor)}
          >
            <AlertTitle>
              {
                statusCode > 700
                  ? 'Success message'
                  : 'Error'
              }
            </AlertTitle>
            {errorMessage[statusCode] || text}
          </Alert>
        </Slide>
      </div>
    );
  }
  return <></>;
};
